/**
 * Generato automaticamente.
 * framework-cmp-procedimenti
 */

export type SortDirection = (typeof SortDirection)[keyof typeof SortDirection];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SortDirection = {
  ASC: 'ASC',
  DESC: 'DESC',
} as const;
